import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Photo } from '../types';

interface PhotosState {
  byId: Record<number, Photo>;
  allIds: number[];
  loading: boolean;
  error: string | null;
}

const initialState: PhotosState = {
  byId: {},
  allIds: [],
  loading: false,
  error: null,
};

const photosSlice = createSlice({
  name: 'photos',
  initialState,
  reducers: {
    setPhotosLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setPhotos: (state, action: PayloadAction<Photo[]>) => {
      state.byId = {};
      state.allIds = [];
      action.payload.forEach((photo) => {
        state.byId[photo.id] = photo;
        state.allIds.push(photo.id);
      });
      state.error = null;
    },
    addPhoto: (state, action: PayloadAction<Photo>) => {
      const photo = action.payload;
      state.byId[photo.id] = photo;
      if (!state.allIds.includes(photo.id)) {
        state.allIds.unshift(photo.id);
      }
    },
    addPhotos: (state, action: PayloadAction<Photo[]>) => {
      action.payload.forEach((photo) => {
        state.byId[photo.id] = photo;
        if (!state.allIds.includes(photo.id)) {
          state.allIds.unshift(photo.id);
        }
      });
    },
    appendPhotos: (state, action: PayloadAction<Photo[]>) => {
      action.payload.forEach((photo) => {
        state.byId[photo.id] = photo;
        if (!state.allIds.includes(photo.id)) {
          state.allIds.push(photo.id);
        }
      });
    },
    updatePhoto: (state, action: PayloadAction<Photo>) => {
      const photo = action.payload;
      state.byId[photo.id] = photo;
    },
    deletePhoto: (state, action: PayloadAction<number>) => {
      const photoId = action.payload;
      delete state.byId[photoId];
      state.allIds = state.allIds.filter((id) => id !== photoId);
    },
    setPhotoError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
    clearPhotos: (state) => {
      state.byId = {};
      state.allIds = [];
      state.error = null;
    },
  },
});

export const {
  setPhotosLoading,
  setPhotos,
  addPhoto,
  addPhotos,
  appendPhotos,
  updatePhoto,
  deletePhoto,
  setPhotoError,
  clearPhotos,
} = photosSlice.actions;

export default photosSlice.reducer;
